// allows for a date time picker to easily set min / max values

const MyDateTimePicker = kendo.ui.DateTimePicker.extend({
  init: function (element: any, options: any) {
    kendo.ui.DateTimePicker.fn.init.call(this, element, options);
  },
  startTime: function (this: any, startTime: any) {
    const timeViewOptions = this.timeView.options;
    timeViewOptions.min = startTime;
    this.timeView.setOptions(timeViewOptions);
  },
  endTime: function (this: any, endTime) {
    const timeViewOptions = this.timeView.options;
    timeViewOptions.max = endTime;
    this.timeView.setOptions(timeViewOptions);
  },
  options: {
    name: "CustomDateTimePicker",
  },
});

kendo.ui.plugin(MyDateTimePicker);

// side effects only
export {};
